import { fetchEmailAuthHint } from './email-auth-hint-client';

/**
 * An `Error` shaped like a GoTrue "email already registered" failure so the
 * existing `isAccountExistsError` matcher lights up the "you already have an
 * account → Sign in" recovery UX. Used when the pre-signup identity guard
 * blocks a canonical-duplicate registration before any auth user is created.
 */
export function makeExistingAccountError(): Error {
  return Object.assign(new Error('User already registered'), {
    code: 'email_exists',
  });
}

/**
 * @name checkSignupIdentityDuplicate
 * @description
 * Pre-signup guard for the BAL-718 duplicate-account vector. Asks the
 * canonical-aware existence oracle (`/api/auth/email-hint`) whether an account
 * already exists for the CANONICAL identity of `email` — i.e. the same real
 * mailbox after gmail dot/plus + RFC-subaddress normalization. When it does, a
 * fresh signup would mint a duplicate auth user (and a duplicate profile), so
 * the caller routes the user to sign-in / reset-password instead.
 *
 * Fails OPEN: on any lookup failure this resolves to `false` (not a duplicate)
 * so infra trouble never blocks a legitimate registration — GoTrue still
 * rejects an EXACT duplicate on its own.
 */
export async function checkSignupIdentityDuplicate(
  email: string,
): Promise<boolean> {
  const hint = await fetchEmailAuthHint(email);
  return hint.exists;
}
